export const UPDATE_STORE_COOKIE_FROM_PLA_STORE = 'UPDATE_STORE_COOKIE_FROM_PLA_STORE';
export const UPDATE_PLA_STORE_ERROR = 'UPDATE_PLA_STORE_ERROR';
